import { StreamIQChannelData } from '@/clients/streamiq/shared/classes/StreamIqChannel'
import { ChannelProps } from '@/types/tv/channels/Channel'
import i18next from 'i18next'

const translate = (key: string, options = {}) => i18next.t(key, options)

export function mapStreamIQToChannelProps(
    channelData: StreamIQChannelData
): ChannelProps {
    return {
        ...channelData,
        id: channelData.id,
        name: channelData.name,
        icon: channelData.images[0]?.url || '',
        lcn: channelData.lcn,
        drm: 0,
        drmId: '',
        origin: 2,
        service: 0,
        uri: '',
        cat: channelData.genres,
        list: [...channelData.genres, 'All'].map((item) => translate(item)),
        licenseProxyUri: '',
        preAuthTokenUri: '',
        certificateUri: null,
        tstvConfig: channelData.tstvConfig,
    }
}
